import { LocationData } from '@/utilities/externalMapUtils';

export function postLocationOpenOnMap(location: LocationData, routing: boolean) {
  let locationOpenMessage = JSON.stringify({
    lat: location.lat,
    lon: location.lon,
    title: location.title,
    routing: routing,
  });
  // ha a lat vagy lon egesz, akkor a jsonban nincs tizedes
  // es akkor nem mukodik :(
  locationOpenMessage = locationOpenMessage.replace(/:(\d+),/g, ':$1.0000,');
  if (window.platformLocationOpen) {
    window.platformLocationOpen.postMessage(locationOpenMessage);
  }
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('platformLocationOpen', locationOpenMessage);
  }
}
